// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"5b4402d7","613":"61933d3a","671":"ad2920f2","801":"7c959091","827":"4059e80d"}[chunkId] + ".chunk.js";
};